import React, { useState } from "react";
import { Box, Tab, Tabs } from "@material-ui/core";
import AllCalibrationPage from "./calibrations-all/calibrations-all-page";
import AveragedCalibrationsPage from "./averaged-calibrations/averaged-calibrations-page";
import TabPanel from "./utils/TabPanel";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CalibrationsPage() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="zakładki kalibracji"
      >
        <Tab label="Wszystkie Kalibracje" {...a11yProps(0)} />
        <Tab label="Uśrednione Kalibracje" {...a11yProps(1)} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <AllCalibrationPage />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AveragedCalibrationsPage />
      </TabPanel>
    </Box>
  );
}
